import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ModuleCommunity } from "@maysoft/circle-common-react";
import { useNavigate, useSearchParams } from "react-router-dom";

import Helpers from "commons/helpers";
import Constants from "constants/index";
import Screens from "constants/screens";
import Strings from "constants/strings";

import { RootState } from "store";
import { DashboardLayout } from "layout";
import { setListPathName } from "store/slice/titleRoute.slice";
import { Mode } from "constants/enum";

const CommunityScreen = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const userInfo = useSelector((state: RootState) => state.userInfo.userProfile);
    const listPathName = useSelector((state: RootState) => state.titleRoute.listPathName);
    const itemPathName = listPathName.find((el) => el.pathName === Screens.COMMUNITY_LIST);

    const [dataRequest] = useState<any>({
        type: searchParams.get("type"),
        searchText: searchParams.get("searchText"),

        totalCount: itemPathName?.totalCount || 0,
        pageNumber: Number(searchParams.get("pageNumber") || 1),
        pageSize: Number(searchParams.get("pageSize") || Constants.ROW_PER_PAGE),
    });

    const idDetail: string = searchParams.get("id");
    const modeList = (Screens.COMMUNITY_LIST.includes(window.location.pathname));
    const pramsMode = !Helpers.isNullOrEmpty(searchParams.get("mode")) ? Number(searchParams.get("mode")) : undefined;

    const [mode, setMode] = useState<Mode>(pramsMode || Mode.View);

    const title = useMemo(() => {
        if (Helpers.isNullOrEmpty(idDetail)) return Strings.COMMUNITY.TITLE_CREATE_VIEW;
        return mode === Mode.View ? Strings.COMMUNITY.TITLE_DETAIL_VIEW : Strings.COMMUNITY.TITLE_UPDATE_VIEW;
    }, [idDetail, mode]);

    const route = useMemo(() => {
        const temp = [{ title: Strings.COMMUNITY.TITLE_MENU, route: Screens.COMMUNITY_LIST }];
        if (Helpers.isNullOrEmpty(idDetail)) {
            temp.push({
                title: Strings.Common.CREATE_NEW,
                route: "",
            });
        } else {
            temp.push({
                title: mode === Mode.View ? Strings.Common.DETAIL : Strings.Common.UPDATE,
                route: "",
            });
        }
        return temp;
    }, [idDetail, mode]);

    useEffect(() => {
        if (Helpers.isNullOrEmpty(idDetail)) {
            setMode(Mode.Create);
        } else {
            setMode(pramsMode || Mode.View);
            navigate(Screens.COMMUNITY_EDIT + `?id=${idDetail}&mode=${pramsMode}`, { replace: true });
        }
    }, [idDetail, pramsMode]);

    const handleGoBack = () => {
        const itemPathName = listPathName.find((el) => el.pathName === Screens.COMMUNITY_LIST);
        navigate(Screens.COMMUNITY_LIST + (itemPathName ? itemPathName.query : ""));
    };

    return (
        <DashboardLayout
            title={modeList ? Strings.COMMUNITY.TITLE_LIST_VIEW : title}
            route={modeList ? [{ title: Strings.COMMUNITY.TITLE_MENU, route: "" }] : route}
        >
            <ModuleCommunity
                keyModuleContainer={{
                    list: { pathName: Screens.COMMUNITY_LIST },
                    detail: { pathName: Screens.COMMUNITY_EDIT },
                }}

                requestGetPaged={dataRequest}
                onGetPaged={({ query, totalCount }) => {
                    dispatch(setListPathName({ pathname: Screens.COMMUNITY_LIST, query, totalCount: totalCount }));
                    navigate(Screens.COMMUNITY_LIST + query, { replace: true });
                }}
                onNavigate={(data) => {
                    if (!Helpers.isNullOrEmpty(data.id)) {
                        navigate(Screens.COMMUNITY_EDIT + `?id=${data.id}&mode=${data.mode}`);
                    } else {
                        navigate(Screens.COMMUNITY_EDIT);
                    }
                }}

                mode={mode}
                idDetail={idDetail}
                onGoBack={handleGoBack}
                folderPath={`${Constants.CloudStorage.TEMP_FOLDER}/${userInfo.identityId}`}
                onChangeMode={(value) => {
                    setMode(value);
                    if (!Helpers.isNullOrEmpty(idDetail)) {
                        navigate(Screens.COMMUNITY_EDIT + `?id=${idDetail}&mode=${value}`, { replace: true });
                    }
                }}
            />
        </DashboardLayout>
    );
};

export default CommunityScreen;
